import { Spin } from 'antd';
import React, { FormEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import * as S from './styles';

interface Props {
    children: React.ReactChild | React.ReactChild[];
    title: string;
    buttonText: string;
    additionalInfo?: string;
    isFetching?: boolean;
    isFormValid?: boolean;
    needHelp?: string;
    noContent?: boolean;
    questionButtonText?: string;
    questionText?: string;
    showBackToLogin?: boolean;
    subTitle?: string;
    useProviderLogin?: boolean;
    onModeChange?: () => void;
    onPasswordResetRequest?: () => void;
    onSingleSignOnRequest?: () => void;
    onSubmit?: (event: FormEvent) => void;
}

export const AuthorizationBox: React.FC<Props> = props => {
    const { t } = useTranslation();
    const history = useHistory();

    return (
        <S.AuthorizationBoxWrapper>
            <S.Header>
                <S.Title>{props.title}</S.Title>
                {props.subTitle && <S.Subtitle>{props.subTitle}</S.Subtitle>}
            </S.Header>

            {props.noContent ? (
                <>{props.children}</>
            ) : (
                <>
                    {props.additionalInfo && <S.SmallInfo>{props.additionalInfo}</S.SmallInfo>}
                    <S.Form error noValidate onSubmit={props.onSubmit} autoComplete="new-password">
                        {props.children}
                        <S.SubmitFormButton
                            type="submit"
                            data-testid="auth-submit-button"
                            disabled={!props.isFormValid}
                        >
                            {props.isFetching ? (
                                <Spin indicator={<S.LoadingIcon type="loading" spin />} />
                            ) : (
                                props.buttonText
                            )}
                        </S.SubmitFormButton>
                    </S.Form>
                </>
            )}

            {props.onSingleSignOnRequest && (
                <S.QuestionWrapper>
                    <S.ChangeModeButton onClick={props.onSingleSignOnRequest}>
                        {t('auth:authorization_box.using_sso')}
                    </S.ChangeModeButton>
                </S.QuestionWrapper>
            )}

            {props.onPasswordResetRequest && (
                <S.QuestionWrapper>
                    <S.ChangeModeButton onClick={props.onPasswordResetRequest}>
                        {t('auth:authorization_box.forgot_your_password')}
                    </S.ChangeModeButton>
                </S.QuestionWrapper>
            )}

            <S.QuestionWrapper>
                <S.Question>{props.questionText}</S.Question>
                <S.ChangeModeButton onClick={props.onModeChange}>
                    {props.questionButtonText}
                </S.ChangeModeButton>
            </S.QuestionWrapper>

            <S.QuestionWrapper>
                <S.ChangeModeButton
                    onClick={() =>
                        window.open(
                            'https://joinmodernhealth.zendesk.com/hc/en-us/articles/360052282832-Member-Registration',
                            '_blank',
                        )
                    }
                >
                    {props.needHelp}
                </S.ChangeModeButton>
            </S.QuestionWrapper>

            {props.showBackToLogin && (
                <S.QuestionWrapper>
                    {props.useProviderLogin ? (
                        <S.ChangeModeButton onClick={() => history.push('/provider-dashboard')}>
                            {t('auth:authorization_box.back_to_provider_login')}
                        </S.ChangeModeButton>
                    ) : (
                        <S.ChangeModeButton onClick={() => history.push('/login')}>
                            {t('auth:authorization_box.back_to_login')}
                        </S.ChangeModeButton>
                    )}
                </S.QuestionWrapper>
            )}
        </S.AuthorizationBoxWrapper>
    );
};

AuthorizationBox.defaultProps = {
    isFormValid: true,
};
